const LikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1701 1L7.00012 8.18V21H19.3101L23.0001 12.4V8H14.6901L15.8101 2.62L14.1701 1ZM5.00012 21H1.00012V9H5.00012V21Z"
        fill="#A9A5B6"
      />
    </svg>
  );
};

export default LikeIcon;
